export const type = [
  { value: "general", label: "General" },
  { value: "hospitality", label: "Hospitality" },
];
